import useLoginCheck from 'hooks/common/useLoginCheck';
import { getDashboardRegisterList } from 'lib/api/dashboard';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

const useDashboardTable = registerType => {
  const [currentPage, setCurrentPage] = useState(1);

  const { isLoading, error, data, refetch } = useQuery(
    ['dashboardRegisterList', registerType, currentPage],
    () => getDashboardRegisterList(registerType, currentPage),
    {
      keepPreviousData: true,
    },
  );
  const totalPage = Math.ceil(data?.data.list.count / 10);
  const registerList = data?.data.list.rows;

  useEffect(() => {
    setCurrentPage(1);
  }, [registerType]);

  useLoginCheck(error?.response, refetch);

  return {
    isLoading,
    error,
    totalPage,
    registerList,
    currentPage,
    setCurrentPage,
  };
};

export default useDashboardTable;
